export default __webpack_public_path__ + "static/media/iphone.f5ed91ea.png";